/* number-counter.js */
$(document).ready(function () {
  // Run counter only once when element first comes into view
  $(".number-counter-value").one("inview", function (event, isInView) {
    if (isInView) {
      var $this = $(this);
      var target = parseInt($this.data("value"), 10) || 0;
      var suffix = $this.next().text(); // grab suffix (like K, +, % if exists)

      $({ countNum: 0 }).animate(
        { countNum: target },
        {
          duration: 2000, // speed of animation
          easing: "swing",
          step: function () {
            $this.text(Math.floor(this.countNum));
          },
          complete: function () {
            $this.text(this.countNum + (suffix ? "" : "")); // final exact value
          },
        }
      );
    }
  });
});
